import { autoinject, bindable } from 'aurelia-framework';
import { Device } from "../../../models/device";
import { applicationLogger } from "../../../logging/logger";
import { TemperatureBaseDevice } from "./temperature-base-device";
import { Store } from "aurelia-store";
import * as State from "../../../store/state";
import IState = State.IState;
import { Api } from "../../../services/api";
import { MdTooltip } from "aurelia-materialize-bridge";
import { I18N } from "aurelia-i18n";
import { TemperatureFormatValueConverter } from "../../../converters/temperature-format"
import { TemperatureScales, TemperatureConverter } from "../../../converters/temperature-value";


@autoinject
export class NetvoxTemperatureHumidity extends TemperatureBaseDevice {
	@bindable humidity;
	constructor(store: Store<IState>, api: Api, i18n: I18N ) {
		super(store, api, i18n);
	}

	activate(device: Device) {
		//applicationLogger.debug(`${NetvoxTemperatureHumidity.name}.activate() called.`);
		this.device = device;
	}

	attached() {
		if (this.tooltip) {
			this.tooltip.html = this.buildToolTip();
		}
	}

}